export default __webpack_public_path__ + "icon-arrow-right.png?da12564b0c765f50ce4123122898ba6e";